<div class="main-content">
	<div class="container-fluid">
		<div class="card">
			<div class="card-header card-header-{{color}}-6 d-flex flex-wrap align-items-center justify-content-between">
				<h4 class="card-title mb-0">
					<button type="button" class="btn btn-link text-white p-0 mr-2" routerLink="/users-list" title="Back">
						<i class="material-icons align-middle">arrow_back</i>
					</button>
					{{ title }}
				</h4>
				<button type="button" class="btn btn-sm btn-light" (click)="refresh()" [disabled]="loading">
					Refresh
				</button>
			</div>
			<div class="card-body text-dark">
				<p class="text-muted small mb-3">
					Shows everyone in Company Setup → Salespeople. <strong>Has app user</strong> means a <code>www_users</code> record is linked to their salesperson code.
					<strong>Extra login</strong> is the <code>smanlogin</code> from salesperson extra — it pre-fills the user id when creating.
					After creating, you are taken to User Edit to set permissions and location access.
				</p>

				<div class="row mb-3">
					<div class="col-md-4">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Show</mat-label>
							<mat-select [formControl]="filterCtrl">
								<mat-option value="all">All salespeople</mat-option>
								<mat-option value="needs_user">Needs app user</mat-option>
								<mat-option value="has_user">Already has app user</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>

				<div class="table-responsive mb-4">
					<table class="table table-sm table-striped table-bordered">
						<thead class="thead-light">
							<tr>
								<th>Code</th>
								<th>Name</th>
								<th>Status</th>
								<th>App user id</th>
								<th>Extra login</th>
								<th>Default loc.</th>
								<th>Email</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let row of filteredRows">
								<td>{{ row.salesmancode }}</td>
								<td>{{ row.salesmanname }}</td>
								<td>
									<span class="badge" [ngClass]="row.has_app_user ? 'badge-success' : 'badge-warning'">{{ statusLabel(row) }}</span>
								</td>
								<td>
									<ng-container *ngIf="row.app_userid">
										<a href="javascript:void(0)" (click)="openEdit(row.app_userid!)">{{ row.app_userid }}</a>
									</ng-container>
									<ng-container *ngIf="!row.app_userid">{{ row.suggested_userid || '—' }}</ng-container>
								</td>
								<td class="text-monospace small">{{ row.smanlogin || '—' }}</td>
								<td>{{ row.defaultloc || '—' }}</td>
								<td>{{ row.smanemail || '—' }}</td>
								<td class="text-nowrap">
									<button
										type="button"
										class="btn btn-sm btn-primary mr-1"
										*ngIf="!row.has_app_user"
										[disabled]="preparingDialog"
										(click)="openCreateDialog(row)"
									>
										{{ preparingDialog ? '…' : 'Create app user' }}
									</button>
									<button
										type="button"
										class="btn btn-sm btn-outline-secondary"
										*ngIf="row.has_app_user"
										(click)="openEdit(row.app_userid!)"
									>
										Edit user
									</button>
								</td>
							</tr>
						</tbody>
					</table>
					<div *ngIf="!loading && !filteredRows.length" class="text-muted">No rows match this filter.</div>
					<mat-progress-bar mode="indeterminate" *ngIf="loading" color="accent"></mat-progress-bar>
				</div>
			</div>
		</div>
	</div>
</div>
